export const environment = {
  production: true,
  buildId: '3435698048122101',
  configFile: 'config.json',
};
